import { EmptyCriterion, PartialSearchCriterion } from '../search-query-model';
import { criterionHasAttributeAndOperator } from '../search-query-model-core-utils';

export function isEmptyCriterion(criterion: PartialSearchCriterion): criterion is EmptyCriterion {
  return (
    criterionHasAttributeAndOperator(criterion) &&
    (criterion.operator === 'exists' || criterion.operator === '!exists')
  );
}
